import { useState } from "react";
import { customAuthAxios } from "../../utils/customAuthAxios";

// ReserveSettingの型定義（エクスポートを追加）
export interface ReserveSetting {
  id?: string;
  reserve_id?: string;
  password?: string;
  restaurant_id?: string;
}

export const useFetchBlocksReserve = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [reserveSetting, setReserveSetting] = useState<ReserveSetting | null>(null);

  const fetchReserveSetting = async (restaurantId: string) => {
    setIsLoading(true);
    try {
      const response = await customAuthAxios.get(`/blocks_reserve/get/${restaurantId}/`);
      setReserveSetting(response.data || null);
    } catch (error) {
      console.error("設定の取得に失敗しました", error);
      setReserveSetting(null);
    } finally {
      setIsLoading(false);
    }
  };

const registerReserve = async (
  restaurantId: string,
  id: string,
  password: string
) => {
  setIsLoading(true);
  try {
    console.log("登録リクエスト送信中...", { restaurantId, id, password });

    const response = await customAuthAxios.post("/blocks_reserve/create/", {
      restaurant_id: restaurantId,
      reserve_id: id,
      password: password,
    });

    console.log("登録API応答:", response.data);
    setReserveSetting(response.data);
    return response.data;
  } catch (error: any) {
    // エラー詳細をログ出力
    if (error.response) {
      console.error("レスポンスエラー:", error.response.status, error.response.data);
    } else {
      console.error("HTTPリクエストエラー:", error.message);
    }
    throw error;
  } finally {
    setIsLoading(false);
  }
};

  return { reserveSetting, isLoading, registerReserve, fetchReserveSetting };
};